import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const TaxProLayout = lazy(() =>
  import('../components/tax-pro/TaxProLayout').then((m) => ({ default: m.TaxProLayout }))
)
const TaxProHubPage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.HubPage }))
)
const TaxProCockpitPage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.CockpitPage }))
)
const TaxProScorePage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.ScorePage }))
)
const TaxProTaxpayerInfoPage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.TaxpayerInfoPage }))
)
const TaxProSpouseInfoPage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.SpouseInfoPage }))
)
const TaxProDependentsPage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.DependentsPage }))
)
const TaxProDrugInsurancePage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.DrugInsurancePage }))
)
const TaxProFiscalQuestionsPage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.FiscalQuestionsPage }))
)
const TaxProPreferencesPage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.PreferencesPage }))
)
const TaxProChecklistPage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.ChecklistPage }))
)
const TaxProSlipsPage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.SlipsPage }))
)
const TaxProSelfEmploymentPage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.SelfEmploymentPage }))
)
const TaxProSEIncomePage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.SEIncomePage }))
)
const TaxProSEExpensesPage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.SEExpensesPage }))
)
const TaxProVehicleExpensesPage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.VehicleExpensesPage }))
)
const TaxProHomeOfficePage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.HomeOfficePage }))
)
const TaxProGstQstPage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.GstQstPage }))
)
const TaxProRentalPropertiesPage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.RentalPropertiesPage }))
)
const TaxProRentalIncomePage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.RentalIncomePage }))
)
const TaxProRentalExpensesPage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.RentalExpensesPage }))
)
const TaxProDeductionsPage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.DeductionsPage }))
)
const TaxProMedicalExpensesPage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.MedicalExpensesPage }))
)
const TaxProDonationsPage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.DonationsPage }))
)
const TaxProEstimatePage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.EstimatePage }))
)
const TaxProOptimizationPage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.OptimizationPage }))
)
const TaxProSubmissionPage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.SubmissionPage }))
)
const TaxProReportExecPage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.ReportExecPage }))
)
const TaxProAuditTrailPage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.AuditTrailPage }))
)
const TaxProSettingsPage = lazy(() =>
  import('../pages/tax-pro').then((m) => ({ default: m.SettingsPage }))
)

export const taxProRoutes: RouteObject[] = [
  {
    path: '/tax-pro',
    element: <TaxProLayout />,
    children: [
      { index: true, element: <TaxProHubPage /> },
      { path: 'cockpit', element: <TaxProCockpitPage /> },
      { path: 'score', element: <TaxProScorePage /> },
      { path: 'taxpayer-info', element: <TaxProTaxpayerInfoPage /> },
      { path: 'spouse-info', element: <TaxProSpouseInfoPage /> },
      { path: 'dependents', element: <TaxProDependentsPage /> },
      { path: 'drug-insurance', element: <TaxProDrugInsurancePage /> },
      { path: 'fiscal-questions', element: <TaxProFiscalQuestionsPage /> },
      { path: 'preferences', element: <TaxProPreferencesPage /> },
      { path: 'checklist', element: <TaxProChecklistPage /> },
      { path: 'slips', element: <TaxProSlipsPage /> },
      { path: 'self-employment', element: <TaxProSelfEmploymentPage /> },
      { path: 'se-income', element: <TaxProSEIncomePage /> },
      { path: 'se-expenses', element: <TaxProSEExpensesPage /> },
      { path: 'vehicle-expenses', element: <TaxProVehicleExpensesPage /> },
      { path: 'home-office', element: <TaxProHomeOfficePage /> },
      { path: 'gst-qst', element: <TaxProGstQstPage /> },
      { path: 'rental-properties', element: <TaxProRentalPropertiesPage /> },
      { path: 'rental-income', element: <TaxProRentalIncomePage /> },
      { path: 'rental-expenses', element: <TaxProRentalExpensesPage /> },
      { path: 'deductions', element: <TaxProDeductionsPage /> },
      { path: 'medical-expenses', element: <TaxProMedicalExpensesPage /> },
      { path: 'donations', element: <TaxProDonationsPage /> },
      { path: 'estimate', element: <TaxProEstimatePage /> },
      { path: 'optimization', element: <TaxProOptimizationPage /> },
      { path: 'submission', element: <TaxProSubmissionPage /> },
      { path: 'report-exec', element: <TaxProReportExecPage /> },
      { path: 'audit-trail', element: <TaxProAuditTrailPage /> },
      { path: 'settings', element: <TaxProSettingsPage /> },
    ],
  },
]
